import React from 'react'

function BlogTour({ setClick }) {
    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucess innerContainerFlex">
                <div className="imageContainer">
                    <img src="/images/wip_blog.gif" alt="" />
                </div>
                <div className="rightContainer">
                    <div className="studentLogos leftMargin">
                        <div></div>
                        <div>
                            <img
                                src="/StudentImg/BreathSchoolLogo.png"
                                alt="icon"
                                width={"30px"}
                            ></img>
                        </div>
                    </div>
                    <div className=" overallMarginHead mt-5" >
                        <h4 className="textColor2"> This Feature is Under Development !!</h4>
                    </div>
                    <div className=" overallMarginHead mt-5" style={{ color: "red" }}>
                        <h2 className=""> Please Stay Tuned For This  EXCITING Feature ^_^</h2>
                    </div>



                    <div className="" style={{ display: "flex", justifyContent: "center", marginLeft: "70%", marginTop: "8%", background: "none" }}>
                        {/* <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button> */}
                        <button
                            style={{ background: "none", padding: "8px 17px", borderRadius: "8px", border: "2px solid #F77F00" }}
                            onClick={() => setClick(false)}
                        >
                            Okay
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogTour